// extracted by mini-css-extract-plugin
export default {"landingPage":"landingpage_landingPage__ydRU2"};